import './Onboarding.css'
import nexbotRobotVideo from '../../assets/videos/0000-0200.mp4';
import step2RobotVideo from '../../assets/videos/0277-0500.mp4';
import step3RobotVideo from '../../assets/videos/0607-0780.mp4';
import SmallLogo from '../../assets/images/small-logo.svg';
import setting from '../../assets/images/setting.svg';
import logoutIcon from '../../assets/images/logout.svg';
import avatar from '../../assets/images/avatar.png';
import topRight from '../../assets/images/top-right.svg';
import topRightGreen from '../../assets/images/top-right-green.svg';
import robotSheet from '../../assets/images/robot-sheet.png';
import asteroids from '../../assets/images/asteroids.png';
import { MdOutlineDone, MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md'
import { logout } from '../../service/authService'
import { useEffect, useMemo, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import exportIcon from '../../assets/images/export.svg'
import csvIcon from '../../assets/images/csv.svg'
import excelIcon from '../../assets/images/excel.svg'
import closeIcon from '../../assets/images/close-white.svg'
import tickRounded from '../../assets/images/tick-rounded.svg'
import { LuDownload } from "react-icons/lu";
import { useNavigate } from 'react-router-dom';
import { MdOutlineFileUpload } from "react-icons/md";
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import axios from 'axios';
import { toast } from 'react-toastify';
import { axiosInstance } from '../../config/axiosConfig';
import { CONFIRM_PROMOCODE } from '../../config/endpoint';
import loaderService from '../../service/loaderService';
import { showError, showSuccess } from '../../service/toastService';



const Onboarding = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const [selectedStep, setSelectedStep] = useState(1)
    const [openOptions, setOpenOptions] = useState(false)
    // const [showWelcome, setShowWelcome] = useState(true);
    const [isShowPassword, setIsShowPassword] = useState(false)
    const [datasetFiles, setDatasetFiles] = useState([]);
    const [isDatasetAgreed, setIsDatasetAgreed] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(2);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [dragOverTarget, setDragOverTarget] = useState(null);
    const handleShow = () => setShow();
    const navigate = useNavigate();
    const [hasPromo, setHasPromo] = useState(false);
    const [promoCode, setPromoCode] = useState('');

    const [stepsCompleted, setStepsCompleted] = useState({
        1: false,
        2: false,
        3: false
    });
    const stepVideos = {
        1: nexbotRobotVideo,
        2: step2RobotVideo,
        3: step3RobotVideo // fallback or add another if you have
    };



    const markStepComplete = async (stepNumber) => {
        const updatedSteps = {
            ...stepsCompleted,
            [stepNumber]: true
        };
        setStepsCompleted(updatedSteps);

    };

    const subcriptionData = [
        {
            id: 1,
            name: "Basic",
            features: [
                "AI tools included",
                "X users supported",
                "24/7 support"
            ],
            amount: 20,
        }, {
            id: 2,
            name: "Pro",
            features: [
                "AI tools included",
                "X users supported",
                "24/7 support"
            ],
            amount: 20,
            popular: true
        },
        {
            id: 3,
            name: "Enterprise",
            features: [
                "AI tools included",
                "X users supported",
                "24/7 support"
            ],
        }
    ]

    const optionRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (optionRef.current && !optionRef.current.contains(event.target)) {
                setOpenOptions(false);
            }
        };

        if (openOptions) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openOptions]);

    // useEffect(() => {
    //     if (show === "analyzing") {
    //         const timer = setTimeout(() => {
    //             handleCompleteStep1()
    //         }, 2000);
    //         return () => clearTimeout(timer);
    //     }
    // }, [show]);
    const handleOpenOption = () => {
        setOpenOptions(true)
        // setShowWelcome(false)
    }
    const openDialogBox = (dialogName) => {
        if (dialogName == 'setup_billing') {
            verifyPromoCode(promoCode);
        } else {
            setShow(dialogName)
            setOpenOptions(false)
        }

    }

    const localDateTime = () => {
        const d = new Date();
        const pad = n => String(n).padStart(2, '0');
        const yyyy = d.getFullYear();
        const MM = pad(d.getMonth() + 1);
        const dd = pad(d.getDate());
        const HH = pad(d.getHours());
        const mm = pad(d.getMinutes());
        const ss = pad(d.getSeconds());
        return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
    };

    const verifyPromoCode = (promoCode) => {
        loaderService.show()
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        const data = { Id: userInfo.UserId, code: promoCode, dateTime: localDateTime() }
        axiosInstance.post(CONFIRM_PROMOCODE, data).then((data) => {
            if (data.success) {
                showSuccess(data.message);
                handleCompleteStep3();
            } else {
                showError(data.message)
            }
        }).catch((err) => {
            showError(err?.response?.data?.message)
        }).finally(() => {
            loaderService.hide()
        })
    };

    const handleCompleteStep1 = () => {
        setShow(false)
        markStepComplete(1)
        setSelectedStep(2)
    }
    const handleCompleteStep2 = () => {
        setShow(false)
        markStepComplete(2)
        setSelectedStep(3)

    }
    const handleCompleteStep3 = () => {
        setShow(false)
        markStepComplete(3)
        setSelectedStep(0)
    }

    const generateReport = () => {
        openDialogBox("analyzing")
        const formData = new FormData();
        formData.append("mode", "upload")
        formData.append("schema_file", datasetFiles[0])
        axios.post("http://98.86.137.237:3000/analyze", formData, {
            headers: {
                Authorization: "Bearer supersecuretoken123",
            },
        }).then((res) => {
            debugger;
            const fileUrl = res.data.download_url;
            window.open(fileUrl, "_blank", "noopener");
            // const fileURL = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
            // const link = document.createElement("a");
            // link.href = fileURL;
            // link.setAttribute("download", "report.pdf");
            // document.body.appendChild(link);
            // link.click();
            // link.remove();
            // handleCompleteStep1()
        }).catch((err) => {
            toast.error(err.message || 'Faild to generate report.')
        }).finally(() => {
            handleCompleteStep1()
        })
    }

    const handleFileUpload = (files) => {
        const fileArray = Array.from(files);
        const validExtensions = ['.sql'];

        const invalidFiles = fileArray.filter(file => {
            const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            return !validExtensions.includes(ext);
        });

        if (invalidFiles.length > 0) {
            showError('Only SQL files are allowed.');
            return;
        }
        setDatasetFiles(prev => [...prev, ...fileArray]);
    };

    const renderDropZone = (type, label) => {
        const inputId = `${type}-upload`;
        const isDragging = dragOverTarget === type;

        const onDragEnter = (e) => {
            e.preventDefault();
            setDragOverTarget(type);
        };

        const onDragLeave = (e) => {
            e.preventDefault();
            setDragOverTarget(null);
        };

        const onDrop = (e) => {
            e.preventDefault();
            setDragOverTarget(null);
            handleFileUpload(e.dataTransfer.files);
        };

        const onDragOver = (e) => e.preventDefault();

        return (
            <div
                className={`drop-section ${isDragging ? 'drag-over' : ''}`}
                onDrop={onDrop}
                onDragOver={onDragOver}
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
            >
                <input
                    type="file"
                    multiple={false}
                    accept=".sql"
                    style={{ display: 'none' }}
                    id={inputId}
                    onChange={(e) => handleFileUpload(e.target.files)}
                />
                <p className='font-14'>Drag & drop or click to upload your schema</p>
                <button className='theme-sky-btn' style={{ color: '#001F29' }} onClick={() => document.getElementById(inputId).click()}>
                    <MdOutlineFileUpload size={20} />
                    <span>{label}</span>
                </button>
                <p className='font-14'> Accepted formats: .sql</p>
            </div>
        );
    };

    const renderFileDetails = (files, type) => (
        files.length > 0 && (
            <div className='drop-section'>
                {files.map((file, index) => (
                    <div className='file-detail' key={index}>
                        <div className='d-flex align-items-center gap-16'>
                            <img src={file.name.endsWith('.xlsx') ? excelIcon : csvIcon} alt="fileIcon" />
                            <div>
                                <p className='font-16' style={{ overflowWrap: 'anywhere' }}>{file.name}</p>
                                <p className='font-14'>Uploaded.</p>
                            </div>
                        </div>
                        <img
                            src={closeIcon}
                            alt="closeIcon"
                            onClick={() => {
                                if (type === 'dataset') {
                                    setDatasetFiles(prev => prev.filter((_, i) => i !== index));
                                }
                            }}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                ))}
            </div>
        )
    );

    const databaseDetail = useMemo(() => {
        return <div className='d-flex flex-column gap-24' style={{ maxWidth: '450px' }}>
            <p className='font-16'>Generate Database Audit Report</p>
            <div className='d-flex flex-column gap-16'>
                <div className='input-container'>
                    <label >Database Type</label>
                    <select name="dbType" >
                        <option value="PostgreSQL">PostgreSQL</option>
                        <option value="MySQL">MySQL</option>
                        <option value="MSSQL">MSSQL</option>
                    </select>
                </div>
                <div className='input-container'>
                    <input type='text' className='input' placeholder='Host' name="host" />
                </div>
                <div className='input-container'>
                    <input type='text' className='input' placeholder='Port' name="port" />
                </div>
                <div className='input-container'>
                    <input type='text' className='input' placeholder='User' name="user" />
                </div>
                <div className='input-container'>
                    <input type={isShowPassword ? 'text' : 'password'} placeholder='Password' className='input' name="password" autoComplete="new-password" />
                    <div className='icon'>
                        {isShowPassword ?
                            <MdOutlineVisibilityOff size={22} color='#C3C6CF' onClick={() => setIsShowPassword(false)} /> :
                            <MdOutlineVisibility size={22} color='#C3C6CF' onClick={() => setIsShowPassword(true)} />
                        }
                    </div>
                </div>
                <div className='input-container'>
                    <input type='text' className='input' placeholder='Database' name="database" />
                </div>
            </div>
            <div className='d-flex gap-16 align-items-center'>
                <input type='checkbox' />
                <span className='font-16'>I agree to let BrainyAgent access and use my database to answer my questions.</span>
            </div>
            <div className='horizontal-line'></div>

            <div className='d-flex justify-content-end w-100'>
                <button className='theme-sky-btn' style={{ borderRadius: '30px' }} onClick={() => openDialogBox("analyzing")}>
                    Generate Report
                </button>
            </div>
        </div>
    }, [stepsCompleted])

    const analizing = useMemo(() => {
        return <div className='d-flex flex-column gap-8'>
            <p className='font-16'>Analyzing your data… this may take a few minutes.</p>
            <p className='font-14'>Analyzing Schema..</p>
            <LinearProgress />
        </div>
    }, [stepsCompleted])


    const importData = useMemo(() => {
        return <div className='d-flex flex-column gap-24' style={{ maxWidth: '450px' }}>
            <p className='font-16'>Import Your Data</p>
            {datasetFiles.length == 0 && renderDropZone('dataset', 'Upload Schema')}
            {renderFileDetails(datasetFiles, 'dataset')}

            <div className='d-flex gap-16 align-items-center'>
                <Checkbox onChange={(e) => setIsDatasetAgreed(e.target.checked)} />
                <span className='font-14'>I agree to let BrainyAgent access and use my database to answer my questions.</span>
            </div>
            <div className='d-flex justify-content-center w-100'>
                <a
                    href="/example-dataset.sql"
                    download="example-dataset.sql"
                    className="theme-outline-blue-btn border-0 d-flex align-items-center gap-2 text-decoration-none"
                >
                    <LuDownload color="black" /> Download Example Schema
                </a>
            </div>
            <div className='horizontal-line'></div>
            <div className='d-flex justify-content-center w-100'>
                <button className='theme-sky-btn' style={{ borderRadius: '30px' }} disabled={!isDatasetAgreed || datasetFiles.length == 0} onClick={() => generateReport()}>
                    Generate Report
                </button>
            </div>
        </div>
    }, [stepsCompleted, datasetFiles, isDatasetAgreed])

    const optimizeDatabase = useMemo(() => {
        return <>
            <p className='font-22'>Do you want us to optimize your database?</p>
            <div className='d-flex justify-content-end w-100 gap-16'>
                <button className='theme-outline-blue-btn' style={{ borderRadius: '30px' }} onClick={() => openDialogBox("handle_it")}>
                    I’ll Handle It
                </button>
                <button className='theme-blue-btn1' style={{ borderRadius: '30px' }} onClick={() => openDialogBox("get_expert_optimization")}>
                    Get Expert Optimization
                </button>
            </div>
        </>
    }, [stepsCompleted])

    const handleIt = useMemo(() => {
        return <div className='d-flex flex-column align-items-center gap-24'>
            <p className='font-22'>You’ve Got This</p>
            <p className='font-16'>You can request optimization help anytime!</p>
            <div className='d-flex justify-content-center w-100 gap-16'>
                <button className='theme-blue-btn1' style={{ borderRadius: '30px' }} onClick={() => handleCompleteStep2()}>
                    Continue
                </button>
            </div>
        </div>
    }, [stepsCompleted])

    const getExpertOptimization = useMemo(() => {
        return <div className='d-flex flex-column align-items-center gap-24'>
            <p className='font-22'>Great! Our team will contact you shortly with the next steps.</p>
            <div className='d-flex justify-content-center w-100 gap-16'>
                <button className='theme-blue-btn1' style={{ borderRadius: '30px' }} onClick={() => handleCompleteStep2()}>
                    Continue
                </button>
            </div>
        </div>
    }, [stepsCompleted])

    const readyToSuperagent = useMemo(() => {
        return <div className='d-flex flex-column align-items-center gap-24'>
            <p className='font-22'>Ready to activate your Superagent?</p>
            <p className='font-16'>Next, you’ll pick a plan, complete payment, and head to your dashboard to confirm setup.</p>
            <div className='d-flex justify-content-center w-100 gap-16'>
                <button className='theme-outline-blue-btn' style={{ borderRadius: '30px' }} onClick={() => setShow(false)}>
                    Cancel
                </button>
                <button className='theme-blue-btn1' style={{ borderRadius: '30px' }} onClick={() => openDialogBox('choose_subscription_plan')}>
                    Continue
                </button>
            </div>
        </div>
    }, [stepsCompleted])

    const chooseSubscriptionPlan = useMemo(() => {
        return <div className='d-flex flex-column gap-24' style={{ minWidth: '1000px' }}>
            <p className='font-40'>Choose a Subscription Plan</p>
            <p className='font-18-dark'>Pick the plan that suits your organization’s needs. You can upgrade anytime</p>
            <div className='subscription-plan-container'>
                {
                    subcriptionData?.map((plan, index) => (
                        <div className={`subscription-plan-card`} key={index}>
                            <div className='subscriptionPlanDetail'>
                                <div className='d-flex align-items-center gap-8 w-100 justify-content-between'>
                                    <p className='font-28-light-white'>{plan.name}</p>
                                    {plan.popular && <span className='font-14 fw-bold p-2' style={{ border: '1px solid #43474E', borderRadius: '30px' }}>Most Popular</span>}
                                </div>
                                <ul className='font-18-dark gap-24 d-flex flex-column'>
                                    {plan.features.map((feature, idx) => (
                                        <li key={idx}>{feature}</li>
                                    ))}
                                </ul>
                                <p className='font-24-white'>
                                    {plan.amount ? `$${plan.amount}/user/month` : ''}
                                </p>
                            </div>
                            {
                                selectedPlan === plan.id
                                    ? <button className='theme-blue-btn2 w-100' style={{ borderRadius: '14px' }} >
                                        <MdOutlineDone /> Selected
                                    </button>
                                    : <button className='theme-blue-btn1 w-100' style={{ borderRadius: '14px' }} onClick={() => setSelectedPlan(plan.id)}>
                                        Choose Plan
                                    </button>
                            }


                        </div>
                    ))
                }
            </div>
            <div className='d-flex align-items-center justify-content-between flex-lg-nowrap flex-md-nowrap flex-wrap w-100 gap-16'>
                <div className='d-flex gap-16 align-items-center w-100'>
                    {/* <input type='checkbox' /> */}
                    <Checkbox
                        id="hasPromo"
                        checked={hasPromo}
                        onChange={(_, checked) => setHasPromo(checked)}
                    />
                    <span className='font-16 text-nowrap'>I have a trial Promo Code</span>

                    {hasPromo && (
                        <div className='input-container' style={{ height: '44px' }}>
                            <input type='text' className='input text-dark' placeholder='Enter Promo Code' name="PromoCode" value={promoCode}
                                onChange={(e) => setPromoCode(e.target.value)} />
                        </div>
                    )}
                </div>
                <div className='d-flex align-items-center justify-content-end flex-wrap w-100 gap-16'>
                    <button className='theme-outline-blue-btn' style={{ borderRadius: '30px' }} onClick={() => setShow(false)}>
                        Cancel
                    </button>
                    <button className='theme-blue-btn1' style={{ borderRadius: '30px' }} onClick={() => openDialogBox('setup_billing')}>
                        Proceed to Pay
                    </button>
                </div>
            </div>
        </div>
    }, [stepsCompleted, selectedPlan, hasPromo, promoCode])

    const setupBilling = useMemo(() => {
        return <div className='d-flex flex-column gap-24' style={{ minWidth: '1000px' }}>
            <p className='font-40'>Set Up Billing</p>
            <p className='font-18-white'>Secure payment powered by Stripe. You can change plans or cancel anytime.</p>
            <div className='row m-0'>
                <div className='col-4' style={{ borderRight: '1px solid #43474E' }}>
                    <p className='font-28-light-white'>Order Summary</p>
                    <div className='row m-0 mt-4'>
                        <div className='col-4 p-0'><p className='font-18-white'>Plan:</p></div>
                        <div className='col-8'><p className='font-18-white'>Basic - Monthly <br /> $20/user/month</p></div>
                    </div>
                    <div className='row m-0 mt-4'>
                        <div className='col-4 p-0'><p className='font-18-white'>Seats:</p></div>
                        <div className='col-8'><p className='font-18-white'>10</p></div>
                    </div>
                    <div className='row m-0 mt-4'>
                        <div className='col-4 p-0'><p className='font-18-white'>Subtotal:</p></div>
                        <div className='col-8'><p className='font-18-white'>$200.00</p></div>
                    </div>
                    <div className='horizontal-line mt-4'></div>
                    <div className='row m-0 mt-4'>
                        <div className='col-4 p-0'><p className='font-18-white'>Due today:</p></div>
                        <div className='col-8'><p className='font-18-white'>$200.00</p></div>
                    </div>
                    <div className='mt-2'>
                        <p className='font-14'>Renews on September 8</p>
                    </div>
                </div>
                <div className='col-8'>
                    <div className='d-flex flex-column gap-16 ps-4'>
                        <div className='input-container'>
                            <input type='text' className='input' placeholder='Name on Card' name="cardName" />
                        </div>
                        <div className='input-container'>
                            <input type='text' className='input' placeholder='Card number' name="cardNumber" />
                        </div>
                        <div className='d-flex gap-16'>
                            <div className='input-container'>
                                <input type='text' className='input' placeholder='Expires on' name="expiresOn" />
                            </div>
                            <div className='input-container'>
                                <input type='text' className='input' placeholder='CVC' name="cvc" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className='d-flex justify-content-end w-100 gap-16'>
                <button className='theme-outline-btn' style={{ borderRadius: '30px' }} onClick={() => openDialogBox('choose_subscription_plan')}>
                    Back to Plans
                </button>
                <button className='theme-sky-btn' style={{ borderRadius: '30px' }} onClick={() => openDialogBox('payment_success')}>
                    Start Subscription
                </button>
            </div>
        </div>
    }, [stepsCompleted, selectedPlan])

    const paymentSuccess = useMemo(() => {
        return <div className='d-flex flex-column align-items-center gap-24'>
            <p className='font-22'>Payment Successful</p>
            <p className='font-16'>Let’s connect Superagent to your system.</p>
            <div className='d-flex justify-content-center w-100 gap-16'>
                <button className='theme-sky-btn' style={{ borderRadius: '30px' }} onClick={() => handleCompleteStep3()}>
                    Continue
                </button>
            </div>
        </div>
    }, [stepsCompleted])

    const dialogMap = {
        database_detail: databaseDetail,
        analyzing: analizing,
        import_data: importData,
        optimize_database: optimizeDatabase,
        handle_it: handleIt,
        get_expert_optimization: getExpertOptimization,
        ready_to_superagent: readyToSuperagent,
        choose_subscription_plan: chooseSubscriptionPlan,
        setup_billing: setupBilling,
        payment_success: paymentSuccess
    };

    const renderModalData = () => dialogMap[show] || null;

    return (
        <>
            <div className="onboarding-container">
                <video
                    className="background-video"
                    src={stepVideos[selectedStep]} // your video path
                    autoPlay
                    loop
                    muted
                    playsInline
                />
                {/* <div className="content-overlay" style={{ backgroundColor: showWelcome ? '' : '#262B2E' }}> */}
                <div className="content-overlay">
                    <div className='w-100 d-flex flex-column gap-24'>
                        <header>
                            <img src={SmallLogo} alt="SmallLogo" />
                            <div className='d-flex gap-24 align-items-center'>
                                <img src={avatar} alt="avatar" className='logoimg' />
                                <span className='userName'>{userInfo?.FirstName}</span>
                                <img src={setting} alt="setting" />
                                <img src={logoutIcon} alt="logout" className='cursor-pointer' onClick={logout} />
                            </div>
                        </header>
                        <div className={`d-flex flex-column justify-content-center gap-16 align-items-start`} style={{ padding: '120px 0px' }}>
                            <h4 className='font-36'>Welcome {userInfo?.FirstName}!</h4>
                            <p className='font-18-white'>Let’s get your Superagent ready.</p>
                        </div>
                        {/* {!showWelcome &&  */}
                        {/* <div className='robot-sheet'>
                            <img src={robotSheet} alt="robotSheet" className='robot-sheet-img' />
                            <img src={asteroids} alt="robotSheet" className='asteroids-img' />
                        </div> */}
                        {/* } */}
                    </div>

                    <div className='step-card-container'>
                        <div className={`step-card ${selectedStep == 1 ? 'active' : ''} ${stepsCompleted[1] ? 'completed' : ''}`} ref={optionRef}>
                            <div className='d-flex justify-content-between align-items-start w-100'>
                                <p className='title'>Check Your AI Readiness</p>
                                {stepsCompleted[1]
                                    ? <img src={tickRounded} alt="completed" />
                                    : <img src={topRight} alt="topRight" className='cursor-pointer' onClick={() => openDialogBox("import_data")} />
                                }

                            </div>
                            <p className='font-12'>Upload your data so we can check if it’s ready for AI processing. </p>


                        </div>
                        <div className={`step-card ${selectedStep == 2 ? 'active' : ''} ${stepsCompleted[2] ? 'completed' : ''}`}>
                            <div className='d-flex justify-content-between align-items-start w-100'>
                                <p className='title'>Optimize for AI Performance</p>
                                {stepsCompleted[2]
                                    ? <img src={tickRounded} alt="completed" />
                                    : <img src={topRight} alt="topRight" className='cursor-pointer' onClick={() => stepsCompleted[1] ? openDialogBox('optimize_database') : {}} />
                                }
                            </div>
                            <p className='font-12'>Refine and enhance your data so Superagent operates at peak precision.</p>
                        </div>
                        <div className={`step-card ${selectedStep == 3 ? 'active' : ''} ${stepsCompleted[3] ? 'completed light-green' : ''}`}>
                            <div className='d-flex justify-content-between align-items-start w-100'>
                                <p className='title'>Activate Superagent</p>
                                {stepsCompleted[3]
                                    ? <img src={topRightGreen} alt="completed" onClick={() => navigate('/new-user')} />
                                    : <img src={topRight} alt="topRight" className='cursor-pointer' onClick={() => stepsCompleted[2] ? openDialogBox('ready_to_superagent') : {}} />
                                }
                            </div>
                            <p className='font-12'>Establish a secure link so your Superagent can begin executing tasks inside your systems.</p>

                        </div>
                    </div>
                </div>
            </div>


            <Modal show={show} onHide={handleClose} className='common-modal' centered>
                <Modal.Body className='common-modal-body'>
                    {renderModalData()}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Onboarding
